import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import styles from '../ReservationCheck/OccasionSelector/occasionSelector.module.css';

const LeadTime = ({ handleSelectButton, selectedButton }) => {
  const { t } = useTranslation();
  const types = [
    {
      value: 'Inmediato',
      label: t('Inmediato'),
    },
    {
      value: '3 meses',
      label: t('3 meses'),
    },
    {
      value: '5 meses',
      label: t('5 meses'),
    },
    {
      value: 'Más de 6 meses',
      label: t('Más de 6 meses'),
    },
  
  ];

  return (
    <>
      <div className='fw-semibold text-primary font-tiny'>{t('Tiempo de compra estimado')}</div>
      <Swiper spaceBetween={10} slidesPerView={'auto'} className={`${styles.swiperContainer} mt-3`}>
        {types.map((p) => (
          <SwiperSlide key={p.value}>
            <button
              onClick={() => handleSelectButton(p.value)}
              className={`font-small fade-up ${styles.occasionButton} ${
                selectedButton === p.value ? styles.selected : null
              }`}
              type='button'
            >
              {p.label}
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default LeadTime;
